<div class="container">
  <mat-card>
    <form [formGroup]="passwordPreferencesForm" (ngSubmit)="submit()">
      <mat-card-content>
        <mat-radio-group class="layout-column gap-10px radio-group-spacing" formControlName="validationPolicyId">
          @for (passwordPreference of passwordPreferencesData; track passwordPreference) {
            <mat-radio-button [value]="passwordPreference.id">
              <span class="description-wrap">{{ passwordPreference.description }}</span>
            </mat-radio-button>
          }
        </mat-radio-group>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="passwordPreferencesForm.pristine"
          *LOSxHasPermission="'UPDATE_PASSWORD_VALIDATION_POLICY'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
